var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M26.6245 12.24V18.4073C26.6245 22.9456 22.9451 26.6265 18.4053 26.6265H8.59221C4.05388 26.6265 0.373047 22.9471 0.373047 18.4073V8.59417C0.373047 4.05583 4.05242 0.375 8.59221 0.375H13.498C18.0364 0.375 21.7172 4.38833 21.7172 8.92667C21.7172 9.78563 22.4537 10.5206 23.3112 10.5206H24.9051C25.8866 10.5206 26.623 11.2571 26.623 12.2385L26.6245 12.24Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.46993 7.39355H14.3572C15.2162 7.39355 15.9512 8.13001 15.9512 8.98751C15.9512 9.84501 15.2147 10.5815 14.3572 10.5815H8.46993C7.61098 10.5815 6.87598 9.84501 6.87598 8.98751C6.87598 8.13001 7.61243 7.39355 8.46993 7.39355ZM20.001 18.6038C20.001 17.7448 19.2645 17.0098 18.407 17.0098H8.47139C7.61243 17.0098 6.87743 17.7463 6.87743 18.6038C6.87743 19.4613 7.61389 20.1977 8.47139 20.1977H18.407C19.266 20.1977 20.001 19.4613 20.001 18.6038Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlog);
export default __webpack_public_path__ + "static/media/Blog.07ced348011f1154667c24a01ff981b9.svg";
export { ForwardRef as ReactComponent };